import { Box, Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import TrendzContainerCard from "../../../components/TrendzContainerCard";

export function SettingAlertPage() {
  const { t } = useTranslation(["common", "social"]);
  const [openDialog, setOpenDialog] = useState(false);
  return (
    <TrendzContainerCard title={t("social:manage_alerts")}>
      <Grid item xs={0.75}></Grid>
      <Grid item xs={10.5}>
        <Box
          display={"flex"}
          justifyContent={"flex-begin"}
          marginBottom={"20px"}
        >
          <Button
            variant="contained"
            color="success"
            style={{ width: "120px", marginRight: "30px" }}
            onClick={() => setOpenDialog(true)}
          >
            {t("common:create")}
          </Button>{" "}
        </Box>
      </Grid>
      <Grid item xs={0.75}></Grid>
    </TrendzContainerCard>
  );
}
